<template>
    <div>
        <div class="inline-block">
            <div class="statusBtn" data-toggle="dropdown">
                <span class="centerIcon">&nbsp; Status</span>
                <i class="material-icons downIcon">arrow_drop_down &nbsp; </i>
            </div>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <span class="dropdown-item" @click="changeStatus('Alive')"> Alive </span>
                <span class="dropdown-item" @click="changeStatus('Dead')"> Dead </span>
                <span class="dropdown-item" @click="changeStatus('Discard')"> Discard </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
};
</script>

<style lang="css" scoped>
	.statusBtn{
		width: 100px;
		height: 30px;
		background-color: #ede8ff;
		border-radius: 20px;
		color: #25265e;
		font-size: 14px;
		display: flex;
		align-items: center;
		font-weight: 600;
		justify-content: center;
	}
	</style>


// WEBPACK FOOTER //
// src/smallComponents/RecordStatus.vue